"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPC_FORWARD_PREFIX = void 0;
exports.PPC_FORWARD_PREFIX = '/css-xp-ppc';
